import { Link } from "react-router-dom";
import { usePublicSignIn } from "./publicSignIn";
import "@/components/marketing/marketing.css";

/**
 * The public org story's own top bar: the logo and Sign in, nothing else.
 * A direct link to an org (an email signature, a bio) lands here, so the page
 * reads as that org's landing page rather than as the marketing site. Sticky
 * in normal flow, so the page needs no offset for it. Sign in opens the
 * page's PublicSignInProvider box. It is the marketing logo bar (`.mk`), the
 * same one the standalone pages use.
 */
export default function PublicOrgHeader() {
  const openSignIn = usePublicSignIn();

  return (
    <div className="mk mk-app__bar">
      <header className="mk-solo__bar">
        <div className="mk-app__bar-inner">
          <Link to="/" className="mk-header__brand" aria-label="Compaire home">
            <img className="mk-header__logo" src="/compaire-logo.svg" alt="" width={240} height={22} />
          </Link>
          {openSignIn && (
            <button type="button" className="mk-btn mk-btn--outline mk-btn--sm" onClick={openSignIn}>
              Sign in
            </button>
          )}
        </div>
      </header>
    </div>
  );
}
